import { render, staticRenderFns } from "./AxShortcutCommentsCount.vue?vue&type=template&id=604e126e&scoped=true&"
import script from "./AxShortcutCommentsCount.vue?vue&type=script&lang=ts&"
export * from "./AxShortcutCommentsCount.vue?vue&type=script&lang=ts&"
import style0 from "./AxShortcutCommentsCount.vue?vue&type=style&index=0&id=604e126e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e126e",
  null
  
)

export default component.exports